/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
import {HTTPCODES} from '../../plugins/types';
/**
 * @module Store/view
 * @description
 */

/**
 * @constant State of
 * @type {object}
 * */
const state = {
    promotions: [],
    context: '',
    fees: []
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getPromotions: state => state.promotions,
    getFees: state => state.fees
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    updatePromotions: (state, payload) => state.promotions = payload,
    addPromotion: (state, payload) => state.promotions.push(payload),
    setContext: (state, payload) => state.context = payload,
    updatePromotion: (state, promotion) => {
        let index = state.promotions.findIndex(prom => prom.id === promotion.id);
        if (index !== -1) {
            state.promotions[index] = promotion;
        }
    },
    removePromotion: (state, id) => {
        let index = state.promotions.findIndex(promotion => id === promotion.id);
        if (index !== -1) {
            state.promotions.splice(index, 1);
        }
    },
    updateFees: (state, payload) => state.fees = payload,
    addFee: (state, payload) => state.fees.push(payload),
    editFee: (state, payload) => {
        let index = state.fees.findIndex(el => el.id === payload.id);
        if(index !== -1) {
            state.fees[index] = payload;
        }
    }
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async setContext ({commit}, context) {
        commit('setContext', context);
    },
    async addPromotionAsync ({commit, rootState}, promotion) {
        try {
            let {data} = await Vue.axios({method: 'POST', url: `${rootState.config.priceServicePort}/promotion`, headers: {Store: state.context}, data: promotion});
            commit('addPromotion', data);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `add promotion ${data.type} for product`
            });
            return data;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add promotion'
            });
            throw new Error(err);
        }
    },
    /**
     * @function updatePromotionAsync
     * @description async action that updates promotion in promotion service
     * @param {Object} promotion - promotion to be updated
     * @returns {Object} res - server response
     * */
    async updatePromotionAsync ({commit, rootState}, promotion) {
        try {
            let {data} = await Vue.axios({method: 'PUT', url: `${rootState.config.priceServicePort}/promotion/${promotion.id}`, headers: {Store: state.context}, data: promotion});
            commit('updatePromotion', data);
            return data;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to updates promotion: ${promotion.id}`
            });
            throw new Error(err);
        }
    },
    /**
     * @function getPromotionByProductIdAsync
     * @description async action that fetches the promotion by given productId
     * @param {String} productId - productId to get promotions for
     * @returns {Object} promotion
     * */
    async getPromotionByProductIdAsync ({commit, rootState}, productId) {
        try {
            let {data} = await Vue.axios({method: 'GET', url: `${rootState.config.priceServicePort}/promotion?productId=${productId}`, headers: {Store: state.context}});
            return data;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to get promotions for product: ${productId}`
            });
            throw new Error(err);
        }
    },
    /**
     * @function getPromotionByProductIdAsync
     * @description async action that fetches the promotion by given productId
     * @param {String} productId - productId to get promotions for
     * @returns {Object} promotion
     * */
    async getPromotionsAsync ({commit, rootState}, productId) {
        try {
            let {data} = await Vue.axios({method: 'GET', url: `${rootState.config.priceServicePort}/promotion`, headers:{Store: state.context}});
            commit('updatePromotions', data.results);
            return data.results;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to get promotions for product: ${productId}`
            });
            throw new Error(err);
        }
    },
    /**
     * @function deletePromotionByIdAsync
     * @description async action that deletes promotion by given promotionId
     * @param {String} promotionId - promotion id
     * @returns {Object} res - server response
     * */
    async deletePromotionByIdAsync ({commit, rootState}, promotionId) {
        try {
            let res = await Vue.axios({method: 'DELETE', url: `${rootState.config.priceServicePort}/promotion/${promotionId}`, headers: {Store: state.context}});
            commit('removePromotion', promotionId);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: 'Promotion deleted'
            });
            return res;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to delete promotion: ${promotionId}`
            });
            throw new Error(err);
        }
    },
    /**
     * @function deleteAllPromotionsAsync
     * @description async action that deletes all promotions
     * @returns {Object} res - server response
     * */
    async deleteAllPromotionsAsync ({commit, rootState}) {
        try {
            let res = await Vue.axios({method: 'DELETE', url: `${rootState.config.priceServicePort}/promotion/`, headers: {Store: state.context}});
            return res;
        } catch (err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to delete all promotions'
            });
            throw new Error(err);
        }
    },
    /**
     * @function setFee
     * @description async action that set fee for order or product
     * @param {Object} feeData - fee data
     * @returns {Object} res - server response
     * */
    async setFee ({commit}, feeData) {
        try {
            return await Vue.axios({method: 'POST', url: '/prices/fee', headers: { Store: state.context }, data: feeData})
                .then(res => {
                    commit('addAlert', {
                        title: 'Successfully ',
                        type: 'success',
                        body: 'Fee added'
                    });
                    return res;
                });
        } catch (err) {
            const {data} = err.response
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: data.msg || `Cannot set fee`
            });
            throw new Error(err);
        }
    },
    /**
     * @function updateFee
     * @description async action that update fee for order or product
     * @param {Object} feeData - fee data
     * @returns {Object} res - server response
     * */
    async updateFee ({commit}, feeData) {
        try {
            await Vue.axios({method: 'PUT', url: `/prices/fee/${feeData.id}`, headers: { Store: state.context }, data: feeData});
            // commit('addAlert', {
            //     title: 'Successfully ',
            //     type: 'success',
            //     body: 'Fee edited'
            // });
        } catch(err) {
            if (err.response && err.response.status >= 400) {
                if (err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'Cannot update fee'
            });
            throw new Error(err);
        }
    },
    /**
     * @function getFee
     * @description async action that get additional fees for shop
     * @returns {Object} res - rees for shop
     * */
    async getFees ({commit}) {
        try {
            let fees = await Vue.axios({method: 'GET', url: '/prices/fee', headers: { Store: state.context }});
            commit('updateFees', fees.data.results);
        } catch(err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'Cannot get fees'
            });
            throw new Error(err);
        }
    },
    /**
     * @function deleteFee
     * @description async action that delete fees for shop
     * @param {Object} feeId - fee id
     * @returns {Object} res - status
     * */
    async deleteFee ({commit, dispatch }, feeId) {
        try {
            await Vue.axios({method: 'DELETE', url: `/prices/fee/${feeId}`, headers: { Store: state.context }});
            dispatch('getFees');
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: 'Fee deleted'
            });
        } catch(err) {
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'Cannot delete fee'
            });
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
